export default __webpack_public_path__ + "static/media/lootbox-vieira-apng.741ffa50.png";